import styled from 'styled-components/macro';
import { hexToRGB } from '@repo-level/core-front';
import { ScUserWallets } from '../Header/UserWallets/styled';
import { ScSelectButton } from 'components/form/primitives/styled';

export const ScSidebar = styled.div<{
  withEmailConfirmationPopup: boolean;
  emailConfirmationPopupHeight: number;
}>`
  width: 176px;
  min-width: 176px;
  position: fixed;
  top: ${({ withEmailConfirmationPopup, emailConfirmationPopupHeight }) =>
    withEmailConfirmationPopup ? `${emailConfirmationPopupHeight}px` : 0};
  left: 8px;
  display: flex;
  flex-direction: column;
  border-radius: 0 0 8px 8px;
  z-index: 1110;

  @media print {
    display: none;
  }

  .ScrollbarsCustom {
    overflow: hidden;
  }

  .scrollbarsWrapper {
    inset: 0 !important;
  }

  .trackY {
    width: 2px !important;
    height: calc(100% - 36px) !important;

    & > div {
      width: 2px !important;
      background: ${({ theme }) => hexToRGB(theme.grayColor4, 0.6)} !important;
    }
  }

  ${ScUserWallets} {
    .selector {
      background: transparent;
    }
  }

  & ${ScSelectButton} {
    margin-top: 16px;

    & > .border::before {
      background-color: ${({ theme }) => theme.grayColor6};
    }
  }
`;

export const ScSidebarContent = styled.div<{ smallGap?: boolean }>`
  background-color: ${({ theme }) => theme.grayColor5};
  padding: 16px 8px;
  border-radius: 0px 0px 12px 12px;
  min-width: 168px;
  transition: all 0.5s ease;
  display: flex;
  flex-direction: column;
  gap: ${({ smallGap }) => (smallGap ? '16px' : '24px')};
  margin-left: 8px;

  & .divider {
    height: 1px;
    width: 100%;
    background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.1)};
  }
`;

export const ScCollapse = styled.div`
  position: relative;
  width: 16px;
  height: 17px;
  transition: 0.3s;
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;

    path {
      fill: ${({ theme }) => theme.secondaryColor};
      transition: 0.3s;
    }
  }

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.whiteColor};
    }
  }
`;

export const ScSidebarSection = styled.div`
  padding: 24px 0 24px 0;
  margin-bottom: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
`;
